export default __webpack_public_path__ + "static/media/shape-2.ed04ff6d.png";